import searchIcon from "@/img/search-icon-latest.svg";
import CityLocation from "@/components/city-location/CityLocation";
import FavCityButton from "@/components/fav-city-button/FavCityButton";
import SearchModal from "@/components/search-modal/SearchModal";

import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { WEATHER_STORE } from "@/store/store";
import { useDispatch, useSelect } from "@wordpress/data";
import { getCurrentLanguage } from "@/helpers/get-current-langage";
import { useState } from "@wordpress/element";
import { useFavorites } from "@/hooks/use-favorites";
import { CityFeature } from "@/schemas/city-schema";
import { LocationType } from "@/types/location-params-type";

import "./style.scss";

export const App = () => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const lang = getCurrentLanguage();
	const { favorites } = useFavorites();
	const { searchCityById, setDailyForecastStationId } = useDispatch(
		WEATHER_STORE,
	) as WeatherDispatch;

	const { cityNameAr, cityNameEn, cityId, userPosition, cityData } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				...store.getCityLocationState(),
				userPosition: store.getCurrentUserLocation(),
				...store.getCityState(),
			};
		},
	);

	const handleSelectLocation = (value: Pick<CityFeature, "properties">) => {
		searchCityById({
			cityId: value.properties.id,
			cityNameAr: value.properties.name_ar,
			cityNameEn: value.properties.name_en,
		});

		setDailyForecastStationId(cityId);
	};

	return (
		<div className="weather-ten-day-search">
			<div className="wrapper">
				<CityLocation
					locationName={lang === "ar" ? cityNameAr : cityNameEn}
					showCity={false}
					favCity={
						<FavCityButton
							showFavEmpty={true}
							locationId={cityId}
							locationNameEn={cityNameEn}
							locationNameAr={cityNameAr}
							isDisabled={false}
						/>
					}
				/>

				<img
					onClick={() => setIsOpen(true)}
					src={searchIcon}
					alt="search icon"
				/>

				<SearchModal
					handleSelectLocation={(value: Pick<CityFeature, "properties">) =>
						handleSelectLocation(value)
					}
					showFav={true}
					placeholder="Search Kuwait stations"
					favorites={favorites}
					locationType={LocationType.KUWAIT_FORECAST}
					cities={cityData}
					userPosition={userPosition}
					isOpen={isOpen}
					closeModal={() => setIsOpen(false)}
				/>
			</div>
		</div>
	);
};

export default App;
